/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';

function useDebounce<T = any>(value?: T, delay = 1000): T | undefined {
  const [debouncedValue, setDebouncedValue] = useState<T | undefined>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
